module.exports = __webpack_public_path__ + "img/story-img1.3db4bee6.jpg";